import { OrganisationTypeEnum } from "@utilities/types";
const organisationTypeOptions = [
    // {
    //     label: "Type de d'entreprise",
    //     value: ''
    // },
    // {
    //     label: OrganisationTypeEnum.Restaurant,
    //     value: OrganisationTypeEnum.Restaurant
    // },
    {
        label: OrganisationTypeEnum.Shop,
        value: OrganisationTypeEnum.Shop
    }
]

export const organisationFormFieldConfigs = [
    { name: "organisationName", type: "text", placeholder: "Nom de l'organisation" },
    { name: "organisationType", type: "select", placeholder: "Type d'organisation", options: organisationTypeOptions, disabled: true },
    { name: "country", type: "text", placeholder: "Pays" },
    { name: "city", type: "text", placeholder: "Ville" },
];


export const organisationValidationRules = {
    organisationType: {
        // required: "Le nom de l'organisation est obligatoire.",
        minLength: {
            value: 3,
            message: "Le nom doit contenir au moins 3 caractères.",
        },
    },
    organisationName: {
        required: "Le nom de l'organisation est obligatoire.",
        minLength: {
            value: 3,
            message: "Le nom doit contenir au moins 3 caractères.",
        },
    },
    city: {
        required: "La ville est obligatoire.",
        minLength: {
            value: 2,
            message: "Le nom de la ville doit contenir au moins 2 caractères.",
        },
    },
    country: {
        required: "Le pays est obligatoire.",
        minLength: {
            value: 2,
            message: "Le nom du pays doit contenir au moins 2 caractères.",
        },
    },
};
